import PropTypes from 'prop-types';
import React from 'react';
import parse from 'html-react-parser';

import useEnrollmentUrl from '../../../hooks/useEnrollmentUrl';
import Button from '../../../components/button/Button';

import './heroSection.scss';

export default function HeroSection(props) {
  const { enrollmentUrl } = useEnrollmentUrl();
  const {
    contentSize,
    title,
    subtitle,
    button,
  } = props;

  return (
    <section className="hero">
      <div className="background" />
      <div
        className="content"
        style={{ width: `${contentSize || 650}px` }}
      >
        <p className="overline salmon">digital sleep clinic</p>
        <h1>
          {parse(title)}
        </h1>
        <h6>
          {parse(subtitle)}
        </h6>
        <Button
          text={button}
          displayArrow
          dataAttr="CTA_clicked_hero"
          className="blue"
          link={enrollmentUrl}
          onClick={() => {
            if (window.posthog) window.posthog.capture('cta_enroll_now', { section: 'hero' });
          }}
        />
      </div>
    </section>
  );
}

HeroSection.defaultProps = {
  contentSize: 650,
};

HeroSection.propTypes = {
  contentSize: PropTypes.number,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  button: PropTypes.string.isRequired,
};
